<template>
  <carousel
    :perPageCustom="[
      [320, 1],
      [768, 1],
    ]"
  >
    <slide v-for="project in projectData" v-bind:key="project._id" class="list-item">
      <router-link :to="{ name: projectLink, params: { _id: project._id } }">
        <div class="project-icon">
          <img
            :src="project.projectIcon ? project.projectIcon : 'https://boon.h2entreprenad.se/icons/icon_noname.jpg'"
          />
        </div>
      </router-link>
      <h2 class="propject-title">{{ project.projectNumber }} {{ project.title }}</h2>
      <h3 class="sub-title">{{ project.projectStartdate }}&nbsp;-&nbsp;{{ project.projectEnddate }}</h3>
      <div class="buttom-text">Svep åt sidan</div>
    </slide>
  </carousel>
</template>
<script>
import { Carousel, Slide } from 'vue-carousel';
import * as Roles from '@/store/roles';
import { mapGetters } from 'vuex';
export default {
  name: 'ProjectSlide',
  props: ['projectData'],
  mounted: function () {},
  computed: {
    ...mapGetters(['hasRole', 'hasSimplePermissions', 'projectList', 'username']),
    projectLink: function () {
      return this.hasRole(Roles.SubContractor) || this.hasRole(Roles.Client) ? 'ProjectPlanEdit' : 'ProjectOverview';
    },
  },
  data() {
    return {};
  },
  components: {
    Carousel,
    Slide,
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Cabin:400,500,500i,600,700|Montserrat:300,300i,400,500,600,600i&display=swap" rel="stylesheet');

@media (max-width: 767px) {
  .VueCarousel-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .list-item {
    padding: 10px;
    text-align: center;
    position: relative;
    width: 100%;
  }
  .project-icon {
    overflow: hidden;
    width: 250px;
    height: 250px;
    /* border: 5px solid #151C30; */
    display: inline-flex;
    border-radius: 100%;
    box-sizing: border-box;
    background: linear-gradient(to right, #151d30, #223c64);
  }
  .project-icon img {
    object-fit: cover;
    min-width: 250px;
    min-height: 250px;
    border-radius: 100%;
    padding: 5px;
  }
  .propject-title {
    margin-top: 30px;
    /* color: #a0aaba; */
    margin-bottom: 10px;
    font-family: Montserrat;
    font-weight: 400;
  }
  .VueCarousel-pagination {
    position: absolute;
    bottom: 45px;
  }
  .VueCarousel-dot.VueCarousel-dot--active {
    background-color: #fdfefe !important;
  }
  .VueCarousel-dot {
    background-color: #929395 !important;
    margin-right: 10px;
  }
  .VueCarousel-dot:focus {
    outline: none !important;
  }
  .sub-title {
    font-size: 0.8em;
    font-weight: 400;
    margin-bottom: 100px;
    font-family: Montserrat;
    /* color: #a0aaba; */
  }
  .buttom-text {
    font-size: 0.8em;
    font-weight: 400;
    font-family: Montserrat;
    /* color: #a0aaba; */
  }
}
@media (max-width: 400px) {
  .project-icon {
    width: 200px;
    height: 200px;
  }
  .project-icon img {
    min-width: 200px;
    min-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projectlist/ProjectSlide.vue